module.exports = __webpack_public_path__ + "img/44.58ec68d1.png";